import {loadStripe} from '@stripe/stripe-js';

let stripePromise;
let STRIPE_PUBLISHABLE_KEY = 'pk_live_51SBFjOElbbKiIYiC0NBhD48WSas5ZtPLLSUmFypOAH0gmyzW1eXTNHII1GW8niFhM10VFnLBlG0cA6UvZEX40lNN008NPI9iwC'

export const getStripe = () => {
	if (!stripePromise) {
		stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
	}
	return stripePromise;
};

// 确认支付
export const confirmPayment = async (stripe, elements, clientSecret) => {
	try {
		const {error} = await stripe.confirmPayment({
			elements,
			clientSecret,
			confirmParams: {
				return_url: `${window.location.origin}/payment-success`,
			},
			redirect: 'if_required',
		});

		if (error) {
			throw error;
		}

		return {
			success: true
		};
	} catch (error) {
		console.error('Payment confirmation error:', error);
		throw error;
	}
};
